import * as React from "react";
import Box from "@mui/material/Box";
import { useField, useFormikContext } from "formik";
import DateAdapter from "@mui/lab/AdapterMoment";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DatePicker from "@mui/lab/DatePicker";
import HandleError from "../HandleError";
import TextField from "../TextField";

export default function DatePickerComponent({ name, ...props }) {
  const [field] = useField({ name, ...props });
  const { setFieldValue } = useFormikContext();
  return (
    <Box
      sx={{
        height: "60px",
      }}
    >
      <LocalizationProvider dateAdapter={DateAdapter}>
        <DatePicker
          {...field}
          {...props}
          onChange={(val) => {
            setFieldValue(field.name, val.format("YYYY-MM-DD"));
          }}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      <HandleError name={name} />
    </Box>
  );
}
